import { rootApi } from "../../api/rootApi";

export const schemeApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSchemeWalletOfAppUserBySchemeId: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/scheme-wallet?scheme_id=${params.scheme_id}&app_user_id=${params.app_user_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    calculateTDSOfScheme: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/scheme-wallet/calc-tds?scheme_id=${params.scheme_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    fetchAllUserWallets: builder.mutation({
      query: ({ body, token, slug }) => {
        return {
            method: "POST",
            url: `/tenant/scheme/all-scheme-wallets`,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
                slug: slug,
            },
            body: body,
        };
      },
    }),
    updateSchemeWalletStatus: builder.mutation({
      query: ({ body, token, slug }) => {
        return {
            method: "POST",
            url: `/tenant/scheme-wallet/status`,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
                slug: slug,
            },
            body: body,
        };
      },
    }),
  }),
});

export const {
    useFetchSchemeWalletOfAppUserBySchemeIdMutation,
    useCalculateTDSOfSchemeMutation,
    useFetchAllUserWalletsMutation,
    useUpdateSchemeWalletStatusMutation,
} = schemeApi;
